import { Injectable } from '@angular/core';
import { NbToastrService, NbGlobalPhysicalPosition, NbToastrConfig } from '@nebular/theme';
@Injectable({ providedIn: 'root' })
  export class NotificationService{
    public position = NbGlobalPhysicalPosition.BOTTOM_RIGHT;
    public limit = 3;
    private readonly duration = 3000;
    constructor(private toastrService: NbToastrService){}

      showToastr(status:string, title:string, options : Partial<NbToastrConfig> = null, millseconds: number = null){
        let _options : Partial<NbToastrConfig> = {limit: this.limit, position: this.position, status: status, duration: millseconds ?? this.duration, icon:''};
        _options = {..._options, ...options};
        this.toastrService.show("", title, _options);
      }
  }
